import React, { forwardRef } from "react"

// eslint-disable-next-line react/display-name
const CustomInput = forwardRef(({ className, type = "text", ...props }, ref) => {
    return (
        <input
            { ...props }
            className={ `border-border border-solid	 w-full hover:border-primary--light active:border-primary--darknight pt-2 pb-2 pl-4 border-2 rounded outline-none ${className}` }
            ref={ ref }
            type={ type }
        />
    )
})

export default CustomInput
